var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.58 15.0496C30 16.6496 30 19.9896 30 19.9896C30 19.9896 30 23.3296 29.58 24.9296C29.36 25.8096 28.68 26.5096 27.82 26.7496C26.26 27.1896 20 27.1896 20 27.1896C20 27.1896 13.74 27.1896 12.18 26.7496C11.32 26.5096 10.64 25.8096 10.42 24.9296C10 23.3296 10 19.9896 10 19.9896C10 19.9896 10 16.6496 10.42 15.0496C10.64 14.1696 11.32 13.4696 12.18 13.2296C13.74 12.8096 20 12.8096 20 12.8096C20 12.8096 26.26 12.8096 27.82 13.2296C28.68 13.4696 29.36 14.1696 29.58 15.0496ZM18.12 23.4296L23.12 20.3096L18.12 17.1896V23.4296Z",
    fill: "#996830"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "#E6D8CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.bfbf8a5b5b85fd4867e897745b9de9f2.svg";
export { ForwardRef as ReactComponent };